import {Component, OnDestroy, OnInit, Renderer, ViewChild, ElementRef} from "@angular/core";
import {BusinessRight} from "../../model/business-right";
import {CurrentBusinessService} from "../../services/communication/currentBusinessService";
import {TweetService} from "../../../services/data/tweet.service";
import {Subscription} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {BusinessService} from "../../../services/data/business.service";
import {CurrentEventService} from "../../../services/communication/currentEventService";
import {FamilyAlbum} from "../../../model/family-album";
import {Tweet} from "../../../model/social/tweet";
import {Page} from "../../../model/page";
import {Business} from "../../../model/business";
import {UrlService} from "../../../services/url.service";
import {AuthentService} from "../../../services/authent.service";
import {TweetWall} from "../../../model/social/tweet-wall";
import {FileUploader, FileUploaderOptions, ParsedResponseHeaders} from "ng2-file-upload";
import {FamiliesFileItem} from "../../../app.component";
import {Picture} from "../../../model/picture";
import {DomSanitizer} from "@angular/platform-browser";

declare const $: any;
declare const document: any;

@Component({
  selector: 'tweet-wall',
  template: require('./tweet-wall.component.html'),
  styles: [
    require('./tweet-wall.component.scss')
  ]
})

export class TweetWallComponent implements OnDestroy, OnInit {

  INTERVAL_CHANGE: number = 3000;
  INTERVAL_LOAD: number = 30000;

  business: Business = new Business();

  tweets: Tweet[] = [];
  tweets2: Tweet[] = [];

  last:number = 1;

  logoIndex: number;

  uploader: FileUploader;
  uploaderOptions: FileUploaderOptions = {};
  uploading: boolean = false;

  private paramSubscription: Subscription = null;

  private eventId: number;
  private event: FamilyAlbum;

  private lastUpdate: number = new Date().getTime()-(60*5*1000);

  tweetsToShow: Tweet[] = [];
  tweetPage: Page<Tweet>;
  pageNumber: number = 0;
  lastPage: boolean = false;
  isLoadingTweet: boolean = false;

  tweetwall: TweetWall;

  @ViewChild('logoInput') fileInput: ElementRef;

  ngOnInit(): void {
    this.paramSubscription = this.activatedRoute.params.subscribe(
      (param: any) => {
        this.eventId = param['eventId'];

        if (this.currentEventService.currentEvent != null) {
          this.eventLoaded(this.currentEventService.currentEvent);
        } else {
          this.businessService.getEvent(this.eventId).subscribe(
            event => this.eventLoaded(event)
          );
        }

        this.initUploader();
      });
  }

  ngOnDestroy(): void {
  }

  constructor(private tweetService: TweetService, private activatedRoute: ActivatedRoute,
              private businessService: BusinessService, private currentEventService: CurrentEventService,
              private urlService: UrlService, private authent: AuthentService,
              private renderer: Renderer, private sanitizer: DomSanitizer) {
    $('nav-bar').remove();
  }

  initUploader() {
    this.uploader = new FileUploader({
      autoUpload: true
    });

    this.setUploaderToken();

    this.uploader.onSuccessItem = (item: FamiliesFileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      let picture = JSON.parse(response);

      this.updateLogo(picture);
      this.uploading = false;
    };

    this.uploader.onErrorItem = (item: any, response: string, status: number, headers: ParsedResponseHeaders) => {
      if (response != null && response != '') {
        let error = JSON.parse(response);

        if (error.errors[0].code == 'constraint.violation') {
          item.errorMessage = 'Mauvais format';
        }

        console.log("onErrorItem " + status, response);
      } else {
        item.errorMessage = 'Erreur d\'ajout';
      }
      this.uploading = false;
    };

    this.uploader.onAfterAddingFile = (item: FamiliesFileItem) => {
      this.uploading = true;
      item.withCredentials = false;
      item.eventId = this.event.id;

      if(this.logoIndex>0) {
        item.url = this.urlService.getTweetWallLogoAddUrl(this.event.id, this.logoIndex);
      } else {
        item.url = this.urlService.getTweetWallAddBackgroundUrl(this.event.id);
      }

      let headers = {
        name: 'Authorization',
        value: 'Bearer ' + this.authent.getToken()
      };
      item.headers = headers;
    }
  }

  updateLogo(picture: Picture) {
    if(this.logoIndex==0) {
      this.tweetwall.background = picture.id;
      this.tweetwall.backgroundUrl = this.urlService.getTweetWallBackgroundUrl(this.event.id);
    }

    if (this.logoIndex == 1) {
      this.tweetwall.logo1 = picture.id;
      this.tweetwall.logo1Url = this.urlService.getTweetWallLogoUrl(this.event.id, picture.id);
    }

    if (this.logoIndex == 2) {
      this.tweetwall.logo2 = picture.id;
      this.tweetwall.logo2Url = this.urlService.getTweetWallLogoUrl(this.event.id, picture.id);
    }

    if (this.logoIndex == 3) {
      this.tweetwall.logo3 = picture.id;
      this.tweetwall.logo3Url = this.urlService.getTweetWallLogoUrl(this.event.id, picture.id);
    }

    this.logoIndex = null;
  }

  setUploaderToken() {
    let headers = {
      name: 'Authorization',
      value: 'Bearer ' + this.authent.getToken()
    };

    this.uploader.options.itemAlias = 'attachment';
    this.uploaderOptions.headers = [headers];
    this.uploader.setOptions(this.uploaderOptions);
  }

  loadedWall(tweetwall: TweetWall) {
    if (tweetwall.logo1 != null) {
      tweetwall.logo1Url = this.urlService.getPhotowallLogoUrl(this.event.id, tweetwall.logo1);
    }
    if (tweetwall.logo2 != null) {
      tweetwall.logo2Url = this.urlService.getPhotowallLogoUrl(this.event.id, tweetwall.logo2);
    }
    if (tweetwall.logo3 != null) {
      tweetwall.logo3Url = this.urlService.getPhotowallLogoUrl(this.event.id, tweetwall.logo3);
    }
    if(tweetwall.background != null) {
      tweetwall.backgroundUrl = this.urlService.getTweetWallBackgroundUrl(this.event.id);
    } else {
      tweetwall.backgroundUrl = this.urlService.getTweetWallBackgroundDefaultUrl();
    }

    this.tweetwall = tweetwall;
  }

  eventLoaded(event: FamilyAlbum) {
    this.event = event;

    this.tweetService.getTweetWall(event.id).subscribe(tweetwall => this.loadedWall(tweetwall));

    this.business.logoPath = this.urlService.getUploadBusinessLogoUrl(this.event.businessId) + '?access_token=' + this.authent.getToken();

    this.launchTimers();
  }

  loadedLastTweets(tweets: Array<Tweet>) {
    tweets = this.separateTweetPhotos(tweets);

    this.tweetsToShow = this.tweetsToShow.concat(tweets);
  }

  separateTweetPhotos(tweets: Tweet[]) {
    tweets.forEach(tweet => {
      if(tweet.medias!=null && tweet.medias.length>1) {
        for(let x=1; x<tweet.medias.length; x++) {
          let newTweet = new Tweet(tweet, tweet.medias[x]);
          tweets.push(newTweet);
        }

        tweet.medias = [tweet.medias[0]];
      }
    });

    return tweets;
  }

  loadTweets(page?: number) {
    this.isLoadingTweet = true;

    if (page == null) {
      if (this.lastPage) {
        this.pageNumber = 1;
      } else {
        this.pageNumber++;
      }
    } else {
      this.pageNumber = page;
    }

    this.businessService.eventTweets(this.event.id, this.pageNumber, 10).subscribe(
      page => this.tweetsLoaded(page)
    );
  }

  tweetsLoaded(page: Page<Tweet>) {
    this.tweetPage = page;

    page.content = this.separateTweetPhotos(page.content);

    for (let tweet of page.content) {
      if (this.tweetsToShow.length >= 20) {
        break;
      }

      this.tweetsToShow.push(tweet);
    }

    this.lastPage = page.last;
    this.isLoadingTweet = false;
  }

  launchTimers() {
    let that = this;

    this.tweetService.getLastTweets(this.eventId, this.lastUpdate).subscribe(tweets => {
      if(tweets.length>0) {
        this.loadedLastTweets(tweets)
      } else {
        this.loadTweets();
      }

      this.lastUpdate = new Date().getTime();
    });

    setInterval(function () {
      that.tweetService.getLastTweets(that.eventId, that.lastUpdate).subscribe(tweets => {
        console.log('loaded tweets : '+tweets.length);

        if(tweets.length>0) {
          that.loadedLastTweets(tweets)
        } else {
          that.loadTweets();
        }

        that.lastUpdate = new Date().getTime();
      });
    }, this.INTERVAL_LOAD);

    setInterval(function () {
      that.changeTweet();
    }, this.INTERVAL_CHANGE);
  }

  changeTweet() {

    if (this.tweetsToShow.length > 0) {
      let tweet = this.tweetsToShow[0];
      tweet.description = tweet.description.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '');
      let imageWidth = 0;

      if(tweet.medias!=null && tweet.medias.length>0) {
        let height = $('.tweets-container-1').css('height').replace('px', '');
        height -= 45;
        let ratio = height / tweet.medias[0].height;
        imageWidth = tweet.medias[0].width * ratio;
      }

      if (this.last == 1) {
        this.tweets.unshift(tweet);
      } else if (this.last == 2) {
        this.tweets2.unshift(tweet);
      }

      this.tweetsToShow.shift();

      if (this.last == 1) {
        if (this.tweets.length > 8) {
          this.tweets.pop();
        }
      } else if (this.last == 2) {
        if (this.tweets2.length > 8) {
          this.tweets2.pop();
        }
      }

      let last = this.last;
      setTimeout(() => {
        let $item = $('.item-' + last + '-' + tweet.id);
        $item.addClass('shown');
        $item.find('.media-container').width(imageWidth);
      }, 150);

      this.changeLast();
    }
  }

  changeLast() {
    if (this.last == 2) {
      this.last = 1;
    } else {
      this.last = 2;
    }
  }

  toggleFullScreen() {
    if ((document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  private isElementInViewport(el) {
    var rect = el.getBoundingClientRect();

    return (
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  getBackgroundImage() {
    return this.sanitizer.bypassSecurityTrustStyle(this.tweetwall.backgroundUrl);
  }

  getColor() {
    return this.tweetwall.backgroundColor;
  }

  getTextColor() {
    return this.tweetwall.textColor;
  }

  updateWall() {
    this.tweetService.updateTweetWall(this.event.id, this.tweetwall).subscribe();
  }

  addLogo(index: number) {
    this.logoIndex = index;

    let event = new MouseEvent('click', {bubbles: true});

    this.renderer.invokeElementMethod(
      this.fileInput.nativeElement, 'dispatchEvent', [event]);
  }

  setLogoToDelete(index: number) {
    this.logoIndex = index;
  }

  cancelLogoDelete() {
    this.logoIndex = null;
  }

  deleteLogo() {
    if(this.logoIndex==0) {
      this.tweetService.deleteBackground(this.event.id).subscribe(
        state => {
          this.tweetwall.background = null;
          this.tweetwall.backgroundUrl = this.urlService.getTweetWallBackgroundDefaultUrl();
        }
      );
    } else {
      this.tweetService.deleteLogo(this.event.id, this.logoIndex).subscribe(
        state => {
          if (this.logoIndex == 1) {
            this.tweetwall.logo1 = null;
            this.tweetwall.logo1Url = null;
          }

          if (this.logoIndex == 2) {
            this.tweetwall.logo2 = null;
            this.tweetwall.logo2Url = null;
          }

          if (this.logoIndex == 3) {
            this.tweetwall.logo3 = null;
            this.tweetwall.logo3Url = null;
          }

          this.logoIndex = null;
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/event/tweet-wall/tweet-wall.component.ts